// extracted by mini-css-extract-plugin
export default {"container":"kg73l","title":"fydSU","ringGrow":"RJ9i4","bodyText":"DMbT3"};